import { render } from "./App.vue?vue&type=template&id=43658333"
const script = {}

import "./App.vue?vue&type=style&index=0&id=43658333&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__